import { ReactNode } from 'react';

interface DashboardPageHeaderProps {
  title: string;
  description?: string;
  videoPlayer?: ReactNode;
  actions?: ReactNode;
}

export function DashboardPageHeader({
  title,
  description,
  videoPlayer,
  actions,
}: DashboardPageHeaderProps) {
  return (
    <>
      {/* Header */}
      <div className="my-4 flex flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {videoPlayer}
          </div>
          {description && <p className="text-sm text-gray-600">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {/* Divider */}
      <div className="bg-primary-100 my-4 h-px w-full" />
    </>
  );
}
